import { createStore, createHook, createStateHook } from 'react-sweet-state';

type InitialState = {
	firstRedactionIdRendered: string | null;
	titleRedactionRenderedForContentId: string | null;
	activeSpotlightIndex: number | null;
	lastActiveSpotlightIndex: number | null;
};

const initialState: InitialState = {
	firstRedactionIdRendered: null,
	titleRedactionRenderedForContentId: null,
	activeSpotlightIndex: null,
	lastActiveSpotlightIndex: null,
};

const Store = createStore({
	initialState,
	actions: {
		setFirstRedactionIdRendered:
			(redactionId: string) =>
			({ getState, setState }) => {
				const { firstRedactionIdRendered } = getState();
				if (firstRedactionIdRendered) return;

				setState({
					firstRedactionIdRendered: redactionId,
				});
			},
		setTitleRedactionRenderedForContentId:
			(contentId: string | null) =>
			({ setState }) => {
				setState({
					titleRedactionRenderedForContentId: contentId,
				});
			},
		resetTour:
			() =>
			({ setState }) => {
				setState({
					activeSpotlightIndex: initialState.activeSpotlightIndex,
					lastActiveSpotlightIndex: initialState.lastActiveSpotlightIndex,
				});
			},
		initiateTour:
			() =>
			({ setState }) => {
				setState({
					activeSpotlightIndex: 0,
				});
			},
		proceedToNext:
			() =>
			({ setState, getState }) => {
				const { activeSpotlightIndex } = getState();
				if (activeSpotlightIndex === null) return;

				setState({
					activeSpotlightIndex: activeSpotlightIndex + 1,
					lastActiveSpotlightIndex: activeSpotlightIndex,
				});
			},
		concludeTour:
			() =>
			({ setState, getState }) => {
				const { activeSpotlightIndex } = getState();

				setState({
					activeSpotlightIndex: null,
					lastActiveSpotlightIndex: activeSpotlightIndex,
				});
			},
	},
});

export const useRedactionsTourState = createHook(Store);
export const useRedactionsTourIsActive = createStateHook(Store, {
	selector: (state) => state.activeSpotlightIndex !== null,
});
